var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhiteBgYellowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F2B90D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00968 4.40428C7.86028 4.26086 7.62289 4.2657 7.47947 4.41511C7.31614 4.58524 7.37499 4.8248 7.4905 4.94553C8.0145 5.45136 8.53804 5.97533 8.98691 6.5498L4.375 6.54981C4.16789 6.54981 4 6.7177 4 6.92481C4 7.13191 4.16789 7.29981 4.375 7.29981L8.98691 7.2998C8.53761 7.87483 8.01439 8.39839 7.49028 8.90429C7.34089 9.04772 7.33604 9.2851 7.47947 9.4345C7.62289 9.58391 7.86043 9.58861 8.00984 9.44518C8.58155 8.89338 9.15049 8.32685 9.63094 7.69266C9.79478 7.47639 10 7.20961 10 6.9248C10 6.64 9.79478 6.37322 9.63094 6.15695C9.1518 5.5245 8.57937 4.95411 8.00968 4.40428Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhiteBgYellowCircle);
export default __webpack_public_path__ + "static/media/arrowRightWhiteBgYellowCircle.5d5fba58e6f7154174ff871879afde7c.svg";
export { ForwardRef as ReactComponent };